import React, {useEffect, useMemo} from 'react';
import {useStore} from '@store/appStore';
import { shallow } from 'zustand/shallow';
import {ListContainer, ListWrapper} from './ListView.styled';
import {animated, useTransition} from 'react-spring';
import {ListItem, MockListItem} from '../ListItem/ListItem';
import {useSearch} from "@providers/SearchProvider";


const mockEntries = Array(15).fill('');
const AnimatedListItem = animated(ListItem);

interface IProps {
  students:any,
  schedule:any,
}

export const ListView = (props:IProps) => {
  const { setListSelection, resetListSelection, massUpdateListSelectionStudent } = useStore(
    (state) => ({
      resetListSelection: state.resetListSelection,
      setListSelection: state.setListSelection,
        listSelection: state.listSelection,
      massUpdateListSelectionStudent: state.massUpdateListSelectionStudent,
    }),
    shallow,
  );
  const { registrationQuery } = useSearch();
  useEffect(() => {
    resetListSelection();
    if (props.students.data?.length > 0) {
      setListSelection(props.students.data);
      if (registrationQuery.forType === "STUDENT")
      {
        let student = props.students.data.find(s => s.username === registrationQuery.forVal)
        massUpdateListSelectionStudent(student.sis_id);
      }
    }
    return () => {};
  }, [props.students.data, props.schedule.data]);
  const itemHeight = 44;

  const transitions = useTransition(
    props.students.data?.map((data, i) => ({
      ...data,
      // add a padding of 10 to the top of the item
      y: i * (itemHeight + 10),
      height: itemHeight,
      // idx: i,
    })),
    {
      key: (item) => item.sis_id,
      from: { height: 0, opacity: 0 },
      leave: { height: 0, opacity: 0 },
      enter: ({ y, height }) => ({ y, height, opacity: 1 }),
      update: ({ y, height }) => ({ y, height }),
      // trail: 10,
    },
  );
  const computedHeight = useMemo(
    () => (props.students.data?.length > 0 ? props.students.data.length * (itemHeight + 10) + 10 : mockEntries.length * itemHeight + 10 + 10),
    [props.students.data],
  );

  return (
    <ListContainer style={{ height: computedHeight }}>
        <ListWrapper style={{ opacity: props.students.data?.length > 0 && props.students.loading ? 0.5 : 1 }}>

          {props.students.data?.length > 0
            ? transitions((style, item, _, index) => (
                <animated.div
                  style={{
                    zIndex: props.students.data.length - index,
                    // @ts-ignore
                    transform: style.y.to((y) => `translate3d(0px, ${y}px, 0px)`),
                    height: style.height,
                    opacity: style.opacity,
                    position: 'absolute',
                    width: '100%',
                  }}
                  key={item.sis_id}
                >
                  <ListItem index={index} content={item} />
                </animated.div>
              ))
            : mockEntries.map((_, i) => (
                <MockListItem
                  key={i}
                  style={{ opacity: 0.5, position: 'absolute', transform: `translate3d(0px, ${i * (itemHeight + 10)}px, 0px)` }}
                />
              ))}
        </ListWrapper>
    </ListContainer>
  );
};
export default ListView;
